import { api } from '@/services/http.service';
import { defineStore } from 'pinia';
import { ElNotification } from 'element-plus';
import { GameCategoryItem } from '@/models/dictionary/game-category.model';

interface GameCategoryListStore {
  gameCategoryList: GameCategoryItem[];
  isGameCategoryListLoading: boolean;
}

export const useGameCategoryListStore = defineStore({
  id: 'GameCategoryListStore',
  state: (): GameCategoryListStore => ({
    gameCategoryList: [],
    isGameCategoryListLoading: false,
  }),
  actions: {
    setGameCategoryListLoading(isLoading: boolean): void {
      this.isGameCategoryListLoading = isLoading;
    },
    getGameCategoryList(): Promise<GameCategoryItem[]> {
      if (this.gameCategoryList.length) {
        return Promise.resolve(this.gameCategoryList);
      }

      this.setGameCategoryListLoading(true);

      return api.dictionary.getGameCategoryListRequest.perform()
        .then((response: GameCategoryItem[]) => {
          this.gameCategoryList = response;

          return response;
        })
        .catch(error => {
          ElNotification({
            title: 'Error',
            message: error.message,
            type: 'error',
          });

          return [];
        })
        .finally(() => {
          this.setGameCategoryListLoading(false);
        });
    },
  },
});
